import React, { Component, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import * as actions from "../../store/actions/index";
import { connect } from "react-redux";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import RenderPhoneInput from "react-phone-input-2";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import CodeVerify from "./CodeVerify";
import withSizes from "react-sizes";
import axios from 'axios';
import PropTypes, { func } from "prop-types";
import { white } from "material-ui/styles/colors";
var phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
const styles = (theme) => ({
  button: {
    width: "250px",
    margin: "0px",
  },
  loading: {
    //display: 'flex',
    alignItems: "center",
    justifyContent: "center",
  },
  bInput: {
    background: "rgba(255, 255, 255, 0.5)",
    outline: "0",
    color: "#99192D",
    wordWrap: "break-word",
    wordBreak: "break-word",
    border: "2px solid #99192D",
    paddingTop: "15px",
    textTransform: 'none',
    paddingBottom: "15px",
    borderRadius: "25px",
    // height: "30px",
    marginLeft: "3px",
    marginRight: "3px",
    boxSizing: "border-box",
    fontSize: "16px",
    "&:hover": {
        color: "white",
      },
  },
  
});

class InputPhoneForm extends Component {
  state = {
    country: "hk",
    phone: "",
    email: "",
    verifyEmail:"",
    isVerifyEmailValid: false,
    isPhoneValid: false,
    respondentEmail: "",
    invalidEmail: false,
    validEmail: false,
    emailSave: false,
    phoneArr:[],
    windowHeight: window.innerHeight,
    windowWidth: window.innerWidth,
  };

  handleOnChange = (event) => {
    this.setState({
      //phone: event.target.value,
      phone: event,
    });
  };

  submitHandler = (event) => {
    console.log('inputPhoneForm submitHandler called')
    event.preventDefault();
    let token = localStorage.getItem("token");
    this.props.onSendSMS(
      this.state.country,
      this.state.phone,
      token,
      this.props.caseId,
      this.props.userType,
      this.state.verifyEmail,
      this.state.isVerifyEmailValid,
      this.props.isSignatureVerifyNeeded
    );
  };



  setPhoneNumber = () => {
    console.log(
      "this.props.claimant_telephone: " + this.props.claimant_telephone
    );
    
    this.setState({
      phone: this.props.claimant_telephone,
    });
  };

validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

  componentDidMount() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    const telephone = this.props.telephone || ""; 

    function IsTelephoneValid(tel){
      return new Promise(async function(resolve, reject){
          try{
              console.log('IsTelephoneValid : '+tel + " | "+(phoneUtil.isValidNumberForRegion(phoneUtil.parse(tel, 'HK'), 'HK')))
              var r  = phoneUtil.isValidNumberForRegion(phoneUtil.parse(tel, 'HK'), 'HK')
              resolve(r)
          }catch(err){
              resolve(false)
          }
      })
    }
    var self = this
    async function validatePhoneNumber(phone) {
      let isValidPhone = await IsTelephoneValid(phone);
      console.log('isValidPhone: ' + isValidPhone);
      self.setState({
        isPhoneValid: isValidPhone,
      });
    }

    validatePhoneNumber(telephone);

    if (telephone) {
      this.setState({
        phone: telephone,
        phoneArr: (''+telephone).split(''),
      });
    }
    let respondentEmail = '';
    if (this.props.caseData.kind_of_claim == 'estate_agent_dispute_seperate_agent'){

      if ((this.props.caseData.a2 == 'purchaser' || this.props.caseData.a2 == 'vendor') && this.props.caseData.a1 == undefined) {
          respondentEmail = this.props.caseData["a12b"]
      }
      else{
          if (this.props.caseData.a1 == 'sole') {
              if (this.props.caseData.a2 == 'vendor') {
                  // respondentEmail = this.props.caseData.namesOfVendors[0].a11a;
                  respondentEmail = this.props.caseData["namesOfVendors"][0]['a11a']
              }
              else if (this.props.caseData.a2 == 'purchaser') {
                  // respondentEmail = this.props.caseData.namesOfPurchasers[0].a12i;
                  respondentEmail = this.props.caseData["namesOfPurchasers"][0]['a12i']
              }
          }
          else if (this.props.caseData.a1 == 'seperate') {
              // respondentEmail = this.props.caseData.namesOfA2[0].a11a;
              respondentEmail = this.props.caseData["namesOfA2"][0]['a11a']
          }
          else if (this.props.caseData.a2 == 'purchaser') {
              // respondentEmail = this.props.caseData.a12b;
              respondentEmail = this.props.caseData["a12b"]
          }
          else if (this.props.caseData.a2 == 'vendor') {
              // respondentEmail = this.props.caseData.a12b;
              respondentEmail = this.props.caseData["a12b"]
          }
      }
    }
    else if (this.props.caseData.kind_of_claim == 'other_dispute') {
        // respondentEmail = this.props.caseData.a16a;
        respondentEmail = this.props.caseData["a16a"]
    }
    else if (this.props.caseData.kind_of_claim == 'SalesOfGoods' || this.props.caseData.kind_of_claim == 'serviceDispute' || this.props.caseData.kind_of_claim == 'insuranceDispute') {
        respondentEmail = this.props.caseData["a16a"]
    }
    else if(this.props.caseData.kind_of_claim == 'creditcard'){
        respondentEmail = this.props.caseData.a16a
    }
    else{
        respondentEmail = this.props.caseData["borrower_email_address"]
    }

    let validEmail = this.validateEmail(respondentEmail);
    console.log('validEmail: '+validEmail+' respondentEmail: '+respondentEmail)
    if (validEmail){
      this.setState({validEmail: true});
    }

    if (this.props.email){
      console.log('this.props.email: '+this.props.email)
      this.setState({verifyEmail: this.props.email});
      this.setState({isVerifyEmailValid: this.validateEmail(this.props.email)});
      if((''+this.props.email).endsWith('@primecredit.com')){
        // setTimeout(() => {
            this.props.handleComplete()
        // }, 2000);
    }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.telephone != this.props.telephone) {
      this.setState({
        phone: this.props.telepone || "",
      });
    }
  }

  handleSaveEmail = () => {
    console.log("handleSaveEmail called");

    let isValid = this.validateEmail(this.state.email);
    if (!isValid) {
      this.setState({ invalidEmail: true });
      return;
    }else{
      this.setState({ invalidEmail: false });
    }

    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/saveRespondentEmail`;
    let payload = {
      caseId: this.props.caseId,
      email: this.state.email
    }
    axios.post(url, payload)
    .then((response) => {
        if(response.data === 'error' || response.data === 'failed'){
            throw (`login ${response.data}`);
        }
        else{
          console.log('save email response: '+response.data);
          this.setState({emailSave: true});
        }
    })
    .catch((error) => {
        console.log(error);
    });
  };

  handleResize = () => {
    this.setState({
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    });
    this.innerWidth = window.innerWidth;
    console.log(
      "Window Size: window.innerHeight: " +
        window.innerHeight +
        " window.innerWidth: " +
        window.innerWidth +
        " div 4: " +
        window.innerWidth / 4
    );
  };
  

  render() {
    const { classes } = this.props;
    
    return (
        <div style={{padding:!this.props.isDesktop?'':'30px', height: this.props.isDesktop ? '70vh' : ''}}>
          
        {/* { this.state.isPhoneValid && !this.props.sendSMS &&  */}
        { this.state.isPhoneValid && !this.state.isVerifyEmailValid && !this.props.sendSMS && 
          <form onSubmit={this.submitHandler} style={{ width:!this.props.isDesktop?'100vw':'', textAlign: !this.props.isDesktop?'center':'' }}>
          <Typography gutterButtom variant='headline'  style={{fontWeight:'bold'}}>
              {this.context.t('Phone Number Verification')}
          </Typography>
          <Typography gutterButtom variant="subtitle1" component="p" style={{color:'#B71C1C', marginTop:'10px',}}>
            {this.context.t( "Please press 'RECEIVE CODE' to get a verification code" )}
          </Typography>

        {this.props.isDesktop && <TextField 
          style={{marginTop:'5px'}}
          id="standard-basic" 
          disabled
          inputProps={{style: {fontSize: 15, color:'black'}}}
          value={this.state.phone}
        />}

        {!this.props.isDesktop && 
          <div style={{width:'100%',textAlign:'center'}}>
            <table style={{width:'100%'}}>
              <tr >
                <td style={{ fontSize:'small',color:'white'}}>+</td>
                <td style={{ fontSize:'small',color:'white'}}>+</td>
                <td style={{borderBottom:'thin solid', fontSize:'xx-large'}}>{this.state.phoneArr[0]}</td>
                <td style={{ fontSize:'small', marginLeft:'2px', marginRight:'2px',color:white}}>+</td>
                <td style={{borderBottom:'thin solid', fontSize:'xx-large'}}>{this.state.phoneArr[1]}</td>
                <td style={{ fontSize:'small', marginLeft:'2px', marginRight:'2px',color:white}}>+</td>
                <td style={{borderBottom:'thin solid', fontSize:'xx-large'}}>{this.state.phoneArr[2]}</td>
                <td style={{ fontSize:'small', marginLeft:'2px', marginRight:'2px',color:white}}>+</td>
                <td style={{borderBottom:'thin solid', fontSize:'xx-large'}}>{this.state.phoneArr[3]}</td>
                <td style={{ fontSize:'small', marginLeft:'2px', marginRight:'2px',color:white}}>+</td>
                <td style={{borderBottom:'thin solid', fontSize:'xx-large'}}>{this.state.phoneArr[4]}</td>
                <td style={{ fontSize:'small', marginLeft:'2px', marginRight:'2px',color:white}}>+</td>
                <td style={{borderBottom:'thin solid', fontSize:'xx-large'}}>{this.state.phoneArr[5]}</td>
                <td style={{ fontSize:'small', marginLeft:'2px', marginRight:'2px',color:white}}>+</td>
                <td style={{borderBottom:'thin solid', fontSize:'xx-large'}}>{this.state.phoneArr[6]}</td>
                <td style={{ fontSize:'small', marginLeft:'2px', marginRight:'2px',color:white}}>+</td>
                <td style={{borderBottom:'thin solid', fontSize:'xx-large'}}>{this.state.phoneArr[7]}</td>
                <td style={{ fontSize:'small', marginLeft:'2px', marginRight:'2px',color:white}}>+</td>
                <td style={{borderBottom:'thin solid', fontSize:'xx-large'}}>{this.state.phoneArr[8]}</td>
                <td style={{ fontSize:'small', marginLeft:'2px', marginRight:'2px',color:white}}>+</td>
                <td style={{borderBottom:'thin solid', fontSize:'xx-large'}}>{this.state.phoneArr[9]}</td>
                <td style={{ fontSize:'small', marginLeft:'2px', marginRight:'2px',color:white}}>+</td>
                <td style={{borderBottom:'thin solid', fontSize:'xx-large'}}>{this.state.phoneArr[10]}</td>
                <td style={{ fontSize:'small', marginLeft:'2px', marginRight:'2px',color:white}}>+</td>
                <td style={{borderBottom:'thin solid', fontSize:'xx-large'}}>{this.state.phoneArr[11]}</td>
                <td style={{ fontSize:'small', marginLeft:'2px', marginRight:'2px',color:white}}>+</td>
                <td style={{borderBottom:'thin solid', fontSize:'xx-large'}}>{this.state.phoneArr[12]}</td>
                <td style={{ fontSize:'small',color:'white'}}>+</td>
                <td style={{ fontSize:'small',color:'white'}}>+</td>
              </tr>
            </table>
          </div>
        }

        

          <br></br>
          {this.props.isLoading ? (
            <div className={classes.button}>
              <CircularProgress
                size={25}
                thickness={2}
                className={classes.loading}
              />
            </div>
          ) : (
            <Button
              variant="contained"
              type="submit"
              color="primary"
              style={{marginTop:'30px', textTransform:'uppercase'}}
              disabled={this.state.loginInProgress}
              className={classes.bInput}
            >
              {this.context.t("Receive Code")}
            </Button>
          )}
          <br></br>
          <br></br>
          <br></br>

          {(this.props.caseData.respondentUniqueId == localStorage.getItem("token")) && !this.state.validEmail && !this.state.emailSave && <Typography gutterButtom variant="headline" component="p" style={{color:'#B71C1C', marginTop:'10px',}}>
            {this.context.t( "Please enter a valid email address for future communication." )}
          </Typography>}
          {(this.props.caseData.respondentUniqueId == localStorage.getItem("token")) && !this.state.validEmail && !this.state.emailSave && <TextField 
            style={{marginTop:'15px'}}
            id="standard-basic" 
            label="Email Address"
            onChange={(event) => this.setState({ email: event.target.value })}
            inputProps={{style: {fontSize: 15, color:'black'}}}
            value={this.state.email}
          />}
          <br></br>
          {(this.props.caseData.respondentUniqueId == localStorage.getItem("token")) && !this.state.validEmail && !this.state.emailSave && <Button
            variant="contained"
            onClick={() => this.handleSaveEmail(this.state.email)}
            color="primary"
            style={{marginTop:'30px', textTransform:'uppercase'}}
            disabled={this.state.loginInProgress}
          >
            {this.context.t("Save Email")}
          </Button>}
          {this.state.emailSave && <Typography gutterButtom variant="headline" component="p" style={{color:'#B71C1C', marginTop:'10px',}}>
            {this.context.t( "Email saved." )}
          </Typography>}
          {this.state.invalidEmail && <Typography gutterButtom variant="headline" component="p" style={{color:'#B71C1C', marginTop:'10px',}}>
            {this.context.t( "Please enter valid email address." )}
          </Typography>}
        
          </form>
        }
        
        {/* { this.state.isVerifyEmailValid && !this.state.isPhoneValid && !this.props.sendSMS &&  */}
        { this.state.isVerifyEmailValid && !this.props.sendSMS && 
          <form onSubmit={this.submitHandler} style={{ width:!this.props.isDesktop?'100vw':'', textAlign: !this.props.isDesktop?'center':'' }}>
          <Typography gutterButtom variant='headline'  style={{fontWeight:'bold'}}>
              {this.context.t('Email Verification')} 
          </Typography>
          <Typography gutterButtom variant="subtitle1" component="p" style={{color:'#B71C1C', marginTop:'10px',}}>
            {this.context.t( "Please press 'RECEIVE CODE' to get a verification code" )}
          </Typography>

        {this.props.isDesktop && <TextField 
          style={{marginTop:'5px', width:'300px'}}
          id="standard-basic" 
          disabled
          inputProps={{style: {fontSize: 15, color:'black'}}}
          value={this.state.verifyEmail}
        />}

        {!this.props.isDesktop && 
          <div style={{width:'100%',textAlign:'center'}}>
            <table style={{width:'100%'}}>
              <tr >
                <td style={{borderBottom:'thin solid', fontSize:'xx-large'}}>{this.state.verifyEmail}</td>
              </tr>
            </table>
          </div>
        }

        

          <br></br>
          {this.props.isLoading ? (
            <div className={classes.button}>
              <CircularProgress
                size={25}
                thickness={2}
                className={classes.loading}
              />
            </div>
          ) : (
            <Button
              variant="contained"
              type="submit"
              color="primary"
              style={{marginTop:'30px', textTransform:'uppercase'}}
              disabled={this.state.loginInProgress}
              className={classes.bInput}
            >
              {this.context.t("Receive Code")}
            </Button>
          )}
          <br></br>
          <br></br>
          <br></br>

          {(this.props.caseData.respondentUniqueId == localStorage.getItem("token")) && !this.state.validEmail && !this.state.emailSave && <Typography gutterButtom variant="headline" component="p" style={{color:'#B71C1C', marginTop:'10px',}}>
            {this.context.t( "Please enter a valid email address for future communication." )}
          </Typography>}
          {(this.props.caseData.respondentUniqueId == localStorage.getItem("token")) && !this.state.validEmail && !this.state.emailSave && <TextField 
            style={{marginTop:'15px'}}
            id="standard-basic" 
            label="Email Address"
            onChange={(event) => this.setState({ email: event.target.value })}
            inputProps={{style: {fontSize: 15, color:'black'}}}
            value={this.state.email}
          />}
          <br></br>
          {(this.props.caseData.respondentUniqueId == localStorage.getItem("token")) && !this.state.validEmail && !this.state.emailSave && <Button
            variant="contained"
            onClick={() => this.handleSaveEmail(this.state.email)}
            color="primary"
            style={{marginTop:'30px', textTransform:'uppercase'}}
            disabled={this.state.loginInProgress}
          >
            {this.context.t("Save Email")}
          </Button>}
          {this.state.emailSave && <Typography gutterButtom variant="headline" component="p" style={{color:'#B71C1C', marginTop:'10px',}}>
            {this.context.t( "Email saved." )}
          </Typography>}
          {this.state.invalidEmail && <Typography gutterButtom variant="headline" component="p" style={{color:'#B71C1C', marginTop:'10px',}}>
            {this.context.t( "Please enter valid email address." )}
          </Typography>}
        
          </form>
        }
        {/* { this.props.isDesktop && <CodeVerify handleComplete={this.props.handleComplete} />} */}
        { this.props.sendSMS && <CodeVerify isSignatureVerifyNeeded={this.props.isSignatureVerifyNeeded} handleComplete={this.props.handleComplete} />}
        </div>
     
    );
  }
}

const mapStateToProps = (state) => {
  let uniqueId = localStorage.getItem("token");
  let userType = "";
  if (state.caseInfo.caseData.claimantUniqueId == uniqueId) {
    userType = "claimant";
  } else if (state.caseInfo.caseData.respondentUniqueId == uniqueId) {
    userType = "respondent";
  }
  else{
    userType = "claimant";
  }
  console.log("verification userType: " + userType);
  console.log(
    "input form verification state.caseInfo.caseData.agreement_type : " +
      state.caseInfo.caseData.agreement_type
  );
  
  if (state.caseInfo.caseData.agreement_type == "EstateAgentDispute") {
    if ((state.caseInfo.caseData.a2 == "purchaser" || state.caseInfo.caseData.a2 == "vendor") && state.caseInfo.caseData.a1 == undefined) {
      // console.log(state?.caseInfo?.caseData?.namesOfA2[0])
      if (userType == "claimant") {
        console.log('@@verification state.caseInfo.caseData.a4: '+state.caseInfo.caseData.a4)

        return {
          isLoading: state.verify.loginInProgressSendSMS,
          sendSMS: state.verify.sendSMS,
          error: state.caseInfo.error,
          telephone: state.caseInfo.caseData.namesOfA2[0].a11b,
          caseId: state.caseInfo.caseId,
          userType: state.caseInfo.userType,
          caseData: state.caseInfo.caseData,
        };

      } else if (userType == "respondent") {
        return {
          isLoading: state.verify.loginInProgressSendSMS,
          sendSMS: state.verify.sendSMS,
          error: state.caseInfo.error,
          telephone: state.caseInfo.caseData.namesOfA2[0].a11b,
          caseId: state.caseInfo.caseId,
          userType: state.caseInfo.userType,
          //telephone: state.userInfo.telephone,
          caseData: state.caseInfo.caseData,
        };
      }
    } else {
      if (userType == "claimant") {
        if (state.caseInfo.caseData.a3c !== undefined) {
          return {
            isLoading: state.verify.loginInProgressSendSMS,
            sendSMS: state.verify.sendSMS,
            error: state.caseInfo.error,
            telephone: state.caseInfo.caseData.a3c,
            caseId: state.caseInfo.caseId,
            userType: state.caseInfo.userType,
            caseData: state.caseInfo.caseData,
          };
        }
      } else if (userType == "respondent") {
        if (state.caseInfo.caseData.a1 == "sole") {
          if (state.caseInfo.caseData.a2 == "vendor") {
            return {
              isLoading: state.verify.loginInProgressSendSMS,
              sendSMS: state.verify.sendSMS,
              error: state.caseInfo.error,
              telephone: state.caseInfo.caseData.namesOfVendors[0].a11b,
              caseId: state.caseInfo.caseId,
              userType: state.caseInfo.userType,
              //telephone: state.userInfo.telephone,
              caseData: state.caseInfo.caseData,
            };
          } else if (state.caseInfo.caseData.a2 == "purchaser") {
            return {
              isLoading: state.verify.loginInProgressSendSMS,
              sendSMS: state.verify.sendSMS,
              error: state.caseInfo.error,
              telephone: state.caseInfo.caseData.namesOfPurchasers[0].a12j,
              caseId: state.caseInfo.caseId,
              userType: state.caseInfo.userType,
              //telephone: state.userInfo.telephone,
              caseData: state.caseInfo.caseData,
            };
          }
        } else if (state.caseInfo.caseData.a1 == "seperate") {
          return {
            isLoading: state.verify.loginInProgressSendSMS,
            sendSMS: state.verify.sendSMS,
            error: state.caseInfo.error,
            telephone: state.caseInfo.caseData.namesOfA2[0].a11b,
            caseId: state.caseInfo.caseId,
            userType: state.caseInfo.userType,
            //telephone: state.userInfo.telephone,
            caseData: state.caseInfo.caseData,
          };
        }
      }
    }
  } else if (state.caseInfo.caseData.agreement_type == "MoneyLent") {
    return {
      isLoading: state.verify.loginInProgressSendSMS,
      sendSMS: state.verify.sendSMS,
      error: state.caseInfo.error,
      telephone: state.caseInfo[`${state.caseInfo.userType}_telephone`],
      caseId: state.caseInfo.caseId,
      userType: state.caseInfo.userType,
      //telephone: state.userInfo.telephone,
      caseData: state.caseInfo.caseData,
    };
  }  else if (state.caseInfo.caseData.agreement_type == "creditcard") {
    return {
      isLoading: state.verify.loginInProgressSendSMS,
      sendSMS: state.verify.sendSMS,
      error: state.caseInfo.error,
      telephone: state.caseInfo[`${state.caseInfo.userType}_telephone`],
      caseId: state.caseInfo.caseId,
      userType: state.caseInfo.userType,
      //telephone: state.userInfo.telephone,
      caseData: state.caseInfo.caseData,
    };
  } else if (state.caseInfo.caseData.agreement_type == "other_dispute") {
    if (userType == "claimant") {
      console.log(
        "verification state.caseInfo.caseData.a8c: " +
          state.caseInfo.caseData.a8c
      );
      if (state.caseInfo.caseData.a8c !== undefined) {
        return {
          isLoading: state.verify.loginInProgressSendSMS,
          sendSMS: state.verify.sendSMS,
          error: state.caseInfo.error,
          telephone: state.caseInfo.caseData.a8c,
          caseId: state.caseInfo.caseId,
          userType: state.caseInfo.userType,
          //telephone: state.userInfo.telephone,
          caseData: state.caseInfo.caseData,
        };
      }
    } else if (userType == "respondent") {
      console.log(
        "verification state.caseInfo.caseData.a8c: " +
          state.caseInfo.caseData.a16b
      );
      if (state.caseInfo.caseData.a16b !== undefined) {
        return {
          isLoading: state.verify.loginInProgressSendSMS,
          sendSMS: state.verify.sendSMS,
          error: state.caseInfo.error,
          telephone: state.caseInfo.caseData.a16b,
          caseId: state.caseInfo.caseId,
          userType: state.caseInfo.userType,
          //telephone: state.userInfo.telephone,
          caseData: state.caseInfo.caseData,
        };
      }
    }
  } else if (state.caseInfo.caseData.agreement_type == 'SalesOfGoods' || 
             state.caseInfo.caseData.agreement_type == 'serviceDispute' || 
             state.caseInfo.caseData.agreement_type == 'insuranceDispute') {
    if (userType == "claimant") {
      return {
        isLoading: state.verify.loginInProgressSendSMS,
        sendSMS: state.verify.sendSMS,
        error: state.caseInfo.error,
        telephone: state.caseInfo.caseData.a8c,
        caseId: state.caseInfo.caseId,
        userType: state.caseInfo.userType,
        //telephone: state.userInfo.telephone,
        caseData: state.caseInfo.caseData,
      };
    } else if (userType == "respondent") {
      return {
        isLoading: state.verify.loginInProgressSendSMS,
        sendSMS: state.verify.sendSMS,
        error: state.caseInfo.error,
        telephone: state.caseInfo.caseData.a16b,
        caseId: state.caseInfo.caseId,
        userType: state.caseInfo.userType,
        //telephone: state.userInfo.telephone,
        caseData: state.caseInfo.caseData,
      };
    }
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSendSMS: (country, phone, token, caseId, userType, verifyEmail, isVerifyEmailValid, isSignatureVerifyNeeded) =>
      dispatch(actions.onSendSMS(country, phone, token, caseId, userType, verifyEmail, isVerifyEmailValid, isSignatureVerifyNeeded)),
  };
};

const mapSizesToProps = sizes => ({
  isMobile: withSizes.isMobile(sizes),
  isTablet : withSizes.isTablet(sizes),
  isDesktop : withSizes.isDesktop(sizes),
  isGtMobile : withSizes.isGtMobile(sizes),
  isGtTablet : withSizes.isGtTablet(sizes),
  isStTablet : withSizes.isStTablet(sizes),
  isStDesktop : withSizes.isStDesktop(sizes),
  isTabletAndGreater : withSizes.isTabletAndGreater(sizes),
  isTabletAndSmaller : withSizes.isTabletAndSmaller(sizes),

})

InputPhoneForm.contextTypes = {
  t: PropTypes.func,
};

// export default withStyles(styles)( connect(mapStateToProps, mapDispatchToProps)(InputPhoneForm));
export default connect( mapStateToProps, mapDispatchToProps )(withSizes(mapSizesToProps)(withStyles(styles)(InputPhoneForm)));